var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Vue } from 'vue-property-decorator';
import WButton from "../../../../../lib/builtin/components/Button";
import { Color } from './widgets/color';
import { Enum } from './widgets/enum';
import { BackgroundImage } from './widgets/backgroundImage';
let Background = class Background extends Vue {
  render() {
    const h = arguments[0];
    const hasBg = /url\(/.test(this.stylePanel.style.backgroundImage);
    return h("div", {
      "class": "ucd-stylePanel-wrapFlexLine"
    }, [h(Color, {
      "attrs": {
        "title": "背景颜色",
        "propKey": "backgroundColor"
      }
    }), h(BackgroundImage, {
      "attrs": {
        "title": "背景图片",
        "propKey": "backgroundImage"
      }
    }), hasBg && [h(WButton, {
      "attrs": {
        "title": '清除'
      },
      "on": {
        "click": () => {
          this.$delete(this.stylePanel.style, 'backgroundImage');
        }
      }
    }), h(Enum, {
      "attrs": {
        "title": "背景图大小",
        "propKey": "backgroundSize",
        "options": this.backgroundSizeOption
      }
    }), h(Enum, {
      "attrs": {
        "title": "背景图重复",
        "propKey": "backgroundRepeat",
        "options": this.backgroundRepeatOption
      }
    })]]);
  }
  get backgroundSizeOption() {
    return [{
      label: '伸缩',
      value: '100% 100%'
    }, {
      label: 'contain',
      value: 'contain'
    }, {
      label: 'cover',
      value: 'cover'
    }];
  }
  get backgroundRepeatOption() {
    return [{
      label: 'no-repeat',
      value: 'no-repeat'
    }, {
      label: 'repeat',
      value: 'repeat'
    }, {
      label: 'repeat-x',
      value: 'repeat-x'
    }, {
      label: 'repeat-y',
      value: 'repeat-y'
    }];
  }
};
__decorate([Inject()], Background.prototype, "stylePanel", void 0);
Background = __decorate([Component({})], Background);
export default Background;
//# sourceMappingURL=Background.js.map
